import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";



export const ScientificContributionInformationValidation = createAsyncThunk(
  "ScientificContributionInformationValidation/ScientificContributionInformationValidation",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ScientificContributionInformationValidation/ScientificContributionInformationValidation",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ValidationScientificContributionSubmitted = createSlice({
  name: "ValidationScientificContributionSubmitted",
  initialState: {
  
    ValidationScientificContributionSubmitted: [],
    loadingValidationScientificContributionSubmitted: false,
    errorValidationScientificContributionSubmitted: null,
  },
  reducers: {
   
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        ScientificContributionInformationValidation.pending,
        (state, action) => {
          console.log(action.payload, "action.payload");

          state.loadingValidationScientificContributionSubmitted = true;
          state.ValidationScientificContributionSubmitted = action.payload;
          state.errorQuestionsAnswers = null;
        }
      )
      .addCase(
        ScientificContributionInformationValidation.fulfilled,
        (state, action) => {
          state.loadingValidationScientificContributionSubmitted = false;
          state.ValidationScientificContributionSubmitted = action.payload;
        }
      )
      .addCase(
        ScientificContributionInformationValidation.rejected,
        (state, action) => {
          state.loadingValidationScientificContributionSubmitted = false;
          state.errorValidationScientificContributionSubmitted = action.payload;
        }
      );
   

  },
});

export default ValidationScientificContributionSubmitted.reducer;
